export enum UnleashFlags {
  AssignmentsPlayerQuestionDeletable = 'next.service.assignments_player.question_deletable',
  RecentsDeletable = 'next.service.recents.recents_deletable',
  NextLearningGoals = 'next.learning_goals',
  WebSockets = 'next.websockets',
  AdaptiveScores = 'next.adaptive_scores',
  CommunityPlatformButton = 'next.community_platform_button',
  ResultsDetailContextMenuEnabled = 'results_detail_context_menu_enabled',
  GetFeedbackThor = 'next.get_feedback_thor',
  CreateFeedbackThor = 'next.create_feedback_thor',
  PrintingOnDemand = 'printing_on_demand',
  CommunityBanner = 'next.community_banner',
  ToetsPersEnabled = 'next.toetspers_link_enabled',
  NewNotifications = 'next.user_service_notifications',
  EditionNba = 'next.edition_nba',
  VocabularyPractice = 'next.vocabulary_practice',
  VocabularyPracticeTextEntry = 'next.vocabulary_practice.text-entry',
  EduAdminArrangementsPage = 'next.edu_admin_arrangements',
  DeviantRekenmoduleEnabled = 'next.deviant_rekenmodule.enabled',
  DarkModeToggle = 'next.dark_mode_toggle',
  TrainerGuidedTour = 'next.trainer_tour',
  NumberingStrategy = 'next.numbering_strategy.enabled',
}

export enum UnleashContext {
  MethodSlug = 'methodSlug',
  LearningLevel = 'learningLevel',
  ArrangementCode = 'arrangementCode',
  ArrangementType = 'arrangementType',
  PublicationSource = 'publicationSource',
  UserReference = 'userReference',
  Cpis = 'cpis',
  BrinCode = 'brinCode',
}
